import './controlzoom.scss';
import { WebMercatorViewport } from '@deck.gl/core';

const ControlZoom = ({ viewState, setViewState }) => {
	const handleZoomInOut = (change) => {
		const newZoom = viewState.zoom + change;
		setViewState({
			...viewState,
			zoom: newZoom,
			bounds: new WebMercatorViewport({ ...viewState, zoom: newZoom }).getBounds(),
		});
	};
	return (
		<div className="zoom-container ">
			<button className="custom-modal-close-btn zoom-in-btn" onClick={() => handleZoomInOut(1)}>
				<svg
					width="18"
					height="18"
					viewBox="0 0 18 18"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M16.6667 7.77778H10V1.11111C10 0.816426 9.88294 0.533811 9.67456 0.325437C9.46619 0.117063 9.18357 0 8.88889 0C8.5942 0 8.31159 0.117063 8.10322 0.325437C7.89484 0.533811 7.77778 0.816426 7.77778 1.11111V7.77778H1.11111C0.816426 7.77778 0.533811 7.89484 0.325437 8.10322C0.117063 8.31159 0 8.5942 0 8.88889C0 9.18357 0.117063 9.46619 0.325437 9.67456C0.533811 9.88294 0.816426 10 1.11111 10H7.77778V16.6667C7.77778 16.9614 7.89484 17.244 8.10322 17.4523C8.31159 17.6607 8.5942 17.7778 8.88889 17.7778C9.18357 17.7778 9.46619 17.6607 9.67456 17.4523C9.88294 17.244 10 16.9614 10 16.6667V10H16.6667C16.9614 10 17.244 9.88294 17.4523 9.67456C17.6607 9.46619 17.7778 9.18357 17.7778 8.88889C17.7778 8.5942 17.6607 8.31159 17.4523 8.10322C17.244 7.89484 16.9614 7.77778 16.6667 7.77778Z"
						fill="currentColor"
					/>
				</svg>
			</button>
			<button className="custom-modal-close-btn zoom-out-btn" onClick={() => handleZoomInOut(-1)}>
				<svg
					width="17"
					height="2"
					viewBox="0 0 17 2"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<line
						x1="1"
						y1="1"
						x2="16"
						y2="1"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
					/>
				</svg>
			</button>
		</div>
	);
};

export default ControlZoom;
